<template>
  <div class="d-flex items-center justify-content-start gap flex-wrap">
    <div class="cards d-flex justify-content-start" v-for="card in listP" :key="card.name">
      <div class="card d-flex items-start justify-content-around flex-column">
        <div class="w-100 d-flex justify-content-center mb-2">
          <p class="h3 w-100 d-flex justify-content-center"><strong>{{ card.name }}</strong></p>
        </div>
        <p class=""><i class="fa fa-phone" aria-hidden="true"></i>
          {{ card.formattedNumber }}</p>
        <p class=""><i class="fa fa-globe" aria-hidden="true"></i>
          {{ card.type == 'WHATS_META' ? "Whats Meta" : "Whats App" }}
        </p>
        <p>
          <i :class="{
            'fa fa-check-square text-success': card.active,
            'fa fa-window-close text-danger': !card.active
          }" aria-hidden="true"></i>
          {{ card.active ? "Ativo" : "Inativo" }}
        </p>
        <div class="d-flex justify-content gap-4">
          <ToogleSwitch id="ToogleSwitchActive" v-model="card.active" />
          <div class="icon-link-margin" @click="openModalQrCode(card.number)" v-if="card.type == 'WHATS_WPP'">
            <i class="fas fa-qrcode"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="add-button-container d-flex justify-content-center align-items-center">
      <defaultbutton v-if="list != 0" class="defaultbutton" :onClick="() => openModalAdd()" btnVariant="btn-third" icon="fas fa-plus"/>
    </div>

    <!-- QR Code Modal -->
    <b-modal id="qr-code-modal" title="QRCODE" @hide="onHideModal" centered>
      <div class="text-center">
        <h2><i class="fas fa-qrcode"></i> QRCODE</h2>
        <img v-if="qrCode" :src="qrCode" alt="QR Code" width="400px">
        <h3 v-else>Você já está conectado</h3>
      </div>
    </b-modal>
  </div>
</template>

<script>
import defaultbutton from '@/components/UI/button/defaultButton.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import NumRepository from '@/shared/http/repositories/access/cadastroNum.js'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'

export default {
  name: 'ProviderList',
  data () {
    return {
      listP: [],
      active: null,
      qrCode: null
    }
  },
  props: {
    list: {
      type: Array
    }
  },
  components: {
    defaultbutton,
    ToogleSwitch
  },
  created () {
    this.onLoad()
  },
  watch: {
    list: {
      handler (newVal) {
        this.listP = []
        this.listP = newVal
      },
      immediate: true
    },
    listP: {
      handler (newVal) {
        newVal.forEach(card => {
          this.$watch(() => card.active, (newVal, oldVal) => {
            if (newVal !== oldVal) {
              this.save(card)
            }
          })
        })
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClick (info) {
      this.$emit('clicked-open', info)
    },
    openModalAdd () {
      this.$emit('clicked-add')
    },
    async openModalQrCode (identifierProvider) {
      try {
        const response = await AtendimentoRepository.GetQrCode({ identifierProvider })
        this.qrCode = response.data.qrCode
        this.$bvModal.show('qr-code-modal')
      } catch (error) {
        console.error('Erro ao carregar QR Code:', error)
      }
    },
    async save (card) {
      const requestConfig = {
        id: card.id,
        active: card.active
      }
      try {
        await NumRepository.update(requestConfig)
      } catch (error) {
        console.error('Error updating data:', error)
      }
    },
    onHideModal () {
      this.qrCode = null
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  border: none;
  color: #ffffff;
  background-color: #04A791;
  min-height: 40px;
  font-weight: bold;
  box-shadow: 0px 10px 20px -10px rgba(0,0,0,0.5);
  border-radius: 3px;
}
.bb {
  border-bottom: 2px solid #000000;
}
p {
  font-size: 18px;
}
.card {
  padding: 1rem 1.5rem;
  color: #000000;
  background-color: #ffffff;
  box-shadow: 0px 10px 20px -10px rgba(0,0,0,0.5);
  min-width: 230px;
  min-height: 220px;
  border-radius: 10px;
}
.gap {
  gap: 4rem;
}
.add-button-container {
  min-width: auto;
  min-height: 220px;
  padding-bottom: 2rem;
}

.icon-link-margin {
  margin-left: 1rem; /* Ajuste o valor conforme necessário */
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/private/configurations/parametros_atendimento/provedores/list/ProvedorList.vue